import posthog from 'posthog-js'

export default {
    install(app) {
        const posthogClient = posthog.init(import.meta.env.VUE_APP_POSTHOG, {
            api_host: import.meta.env.VUE_APP_POSTHOG_URL,
            autocapture: false,
            capture_pageview: true,
        })

        // Vue 3 plugin API
        if (app?.config?.globalProperties) {
            app.config.globalProperties.$posthog = posthogClient
            return
        }
    },
}
